import type { NylasThread, NylasMessage } from "@equaliq/api-model-v2";

const DEMO_GRANT_ID = "demo-grant-001";
const DEMO_CONNECTION_EMAIL = "demo@equaliq.com";

export const mockThreads: NylasThread[] = [
  {
    threadMetadataId: "thread-meta-1",
    externalThreadId: "ext-thread-1",
    provider: "google",
    connectionEmail: DEMO_CONNECTION_EMAIL,
    lastMessageAt: "2025-01-08T10:30:00Z",
    messageCount: 5,
    summary: "Artist Recording Deal - Signature Required",
    priority: 5,
    labels: ["inbox", "important"],
    ragKeywords: ["recording deal", "signature", "royalty split", "territory"],
    analyzed: true,
    analyzedAt: "2025-01-08T11:00:00Z",
    createdAt: "2025-01-07T14:00:00Z",
    updatedAt: "2025-01-08T10:30:00Z",
  },
  {
    threadMetadataId: "thread-meta-2",
    externalThreadId: "ext-thread-2",
    provider: "google",
    connectionEmail: DEMO_CONNECTION_EMAIL,
    lastMessageAt: "2025-01-08T09:15:00Z",
    messageCount: 3,
    summary: "Sony Music Partnership - Deal Progress Update",
    priority: 3,
    labels: ["inbox"],
    ragKeywords: ["sony", "partnership", "financial projections", "negotiations"],
    analyzed: true,
    analyzedAt: "2025-01-08T09:30:00Z",
    createdAt: "2025-01-07T11:00:00Z",
    updatedAt: "2025-01-08T09:15:00Z",
  },
  {
    threadMetadataId: "thread-meta-3",
    externalThreadId: "ext-thread-3",
    provider: "google",
    connectionEmail: DEMO_CONNECTION_EMAIL,
    lastMessageAt: "2025-01-08T08:05:00Z",
    messageCount: 2,
    summary: "Amendment #1 - Review Requested",
    priority: 4,
    labels: ["inbox", "important"],
    ragKeywords: ["amendment", "payment schedule", "review"],
    analyzed: true,
    analyzedAt: "2025-01-08T08:15:00Z",
    createdAt: "2025-01-08T08:00:00Z",
    updatedAt: "2025-01-08T08:05:00Z",
  },
  {
    threadMetadataId: "thread-meta-4",
    externalThreadId: "ext-thread-4",
    provider: "google",
    connectionEmail: DEMO_CONNECTION_EMAIL,
    lastMessageAt: "2025-01-07T17:00:00Z",
    messageCount: 2,
    summary: "Producer Agreement - Analysis Complete",
    priority: 2,
    labels: ["inbox"],
    ragKeywords: ["producer agreement", "analysis", "IP ownership", "payment terms"],
    analyzed: true,
    analyzedAt: "2025-01-07T17:15:00Z",
    createdAt: "2025-01-07T16:30:00Z",
    updatedAt: "2025-01-07T17:00:00Z",
  },
  {
    threadMetadataId: "thread-meta-5",
    externalThreadId: "ext-thread-5",
    provider: "google",
    connectionEmail: DEMO_CONNECTION_EMAIL,
    lastMessageAt: "2025-01-07T15:00:00Z",
    messageCount: 4,
    summary: "Netflix Sync License - Exclusivity Negotiation",
    priority: 3,
    labels: ["inbox"],
    ragKeywords: ["netflix", "sync license", "exclusivity", "fee structure"],
    analyzed: true,
    analyzedAt: "2025-01-07T15:10:00Z",
    createdAt: "2025-01-07T10:00:00Z",
    updatedAt: "2025-01-07T15:00:00Z",
  },
  {
    threadMetadataId: "thread-meta-6",
    externalThreadId: "ext-thread-6",
    provider: "google",
    connectionEmail: DEMO_CONNECTION_EMAIL,
    lastMessageAt: "2025-01-05T14:00:00Z",
    messageCount: 3,
    summary: "Brand Partnership / NIL Deal - Expiring Soon",
    priority: 3,
    labels: ["inbox", "important"],
    ragKeywords: ["brand partnership", "NIL", "renewal", "expiring"],
    analyzed: true,
    analyzedAt: "2025-01-05T14:30:00Z",
    createdAt: "2025-01-05T09:00:00Z",
    updatedAt: "2025-01-05T14:00:00Z",
  },
];

function ts(iso: string): number {
  return Math.floor(new Date(iso).getTime() / 1000);
}

export const mockThreadMessages: NylasMessage[] = [
  // Thread 1 — Artist Recording Deal
  {
    id: "demo-msg-1-1",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-1",
    subject: "Artist Recording Deal - Signature Required",
    snippet: "Hey team, I've reviewed the initial draft of the Artist Recording Deal...",
    body: "<p>Hey team, I've reviewed the initial draft of the Artist Recording Deal. Overall looks good, but I have a few questions about the royalty split in Section 4.2.</p>",
    from: [{ name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }, { name: "Legal Team", email: "legal@equaliq.demo" }],
    date: ts("2025-01-07T14:00:00Z"),
    unread: false,
    folders: ["INBOX"],
  },
  {
    id: "demo-msg-1-2",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-1",
    subject: "Re: Artist Recording Deal - Signature Required",
    snippet: "Thanks Adam. I've updated Section 4.2 based on your feedback...",
    body: "<p>Thanks Adam. I've updated Section 4.2 based on your feedback. The royalty structure now clearly outlines the 70/30 split we discussed, with provisions for digital streaming vs physical sales.</p>",
    from: [{ name: "Legal Team", email: "legal@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }, { name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    date: ts("2025-01-07T16:30:00Z"),
    unread: false,
    folders: ["INBOX"],
  },
  {
    id: "demo-msg-1-3",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-1",
    subject: "Re: Artist Recording Deal - Signature Required",
    snippet: "This looks much better. Can we also add the territory restrictions we talked about last week?",
    body: "<p>This looks much better. Can we also add the territory restrictions we talked about last week?</p>",
    from: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    to: [{ name: "Legal Team", email: "legal@equaliq.demo" }, { name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    date: ts("2025-01-07T17:15:00Z"),
    unread: false,
    folders: ["INBOX", "SENT"],
  },
  {
    id: "demo-msg-1-4",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-1",
    subject: "Re: Artist Recording Deal - Signature Required",
    snippet: "Absolutely. I've added Section 7 to cover territory restrictions...",
    body: "<p>Absolutely. I've added Section 7 to cover territory restrictions. The contract now explicitly covers North America and Europe, with separate negotiation required for APAC territories.</p>",
    from: [{ name: "Legal Team", email: "legal@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }, { name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    date: ts("2025-01-08T09:00:00Z"),
    unread: false,
    folders: ["INBOX"],
  },
  {
    id: "demo-msg-1-5",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-1",
    subject: "Re: Artist Recording Deal - Signature Required",
    snippet: "The contract is ready for your final review and signature...",
    body: "<p>The contract is ready for your final review and signature. Please review Section 4.2 (royalties), Section 7 (territories), and the updated payment schedule in Section 9. Deadline for signature is December 20th.</p>",
    from: [{ name: "Legal Team", email: "legal@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    date: ts("2025-01-08T10:30:00Z"),
    unread: true,
    starred: true,
    folders: ["INBOX", "IMPORTANT"],
  },

  // Thread 2 — Sony Music Partnership
  {
    id: "demo-msg-2-1",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-2",
    subject: "Sony Music Partnership - Deal Progress Update",
    snippet: "I've connected with the Sony team and they're excited to move forward...",
    body: "<p>I've connected with the Sony team and they're excited to move forward. They're requesting some additional financial projections for Q1-Q2.</p>",
    from: [{ name: "Roger Goodell", email: "roger.goodell@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    date: ts("2025-01-07T11:00:00Z"),
    unread: false,
    folders: ["INBOX"],
  },
  {
    id: "demo-msg-2-2",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-2",
    subject: "Re: Sony Music Partnership - Deal Progress Update",
    snippet: "That's great news! I can pull together those projections by end of day...",
    body: "<p>That's great news! I can pull together those projections by end of day. Should I include the streaming metrics as well?</p>",
    from: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    to: [{ name: "Roger Goodell", email: "roger.goodell@equaliq.demo" }],
    date: ts("2025-01-07T14:30:00Z"),
    unread: false,
    folders: ["INBOX", "SENT"],
  },
  {
    id: "demo-msg-2-3",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-2",
    subject: "Re: Sony Music Partnership - Deal Progress Update",
    snippet: "Great news! We've moved to the next stage. Sony has approved the initial terms...",
    body: "<p>Great news! We've moved to the next stage. Sony has approved the initial terms and we're now in active negotiations. The deal is officially marked as In Progress. Next steps: finalize the recording contract and set up the first studio session.</p>",
    from: [{ name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }, { name: "Roger Goodell", email: "roger.goodell@equaliq.demo" }],
    date: ts("2025-01-08T09:15:00Z"),
    unread: true,
    folders: ["INBOX"],
  },

  // Thread 3 — Amendment #1
  {
    id: "demo-msg-3-1",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-3",
    subject: "Amendment #1 - Review Requested",
    snippet: "I've shared Amendment #1 for your review. This amendment addresses the payment schedule changes...",
    body: "<p>I've shared Amendment #1 for your review. This amendment addresses the payment schedule changes we discussed last week. Key changes are in Section 3 and Section 5.</p>",
    from: [{ name: "Legal Team", email: "legal@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }, { name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    date: ts("2025-01-08T08:00:00Z"),
    unread: true,
    starred: true,
    folders: ["INBOX", "IMPORTANT"],
  },
  {
    id: "demo-msg-3-2",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-3",
    subject: "Re: Amendment #1 - Review Requested",
    snippet: "Please review by EOD tomorrow if possible...",
    body: "<p>Please review by EOD tomorrow if possible. Adam will need to approve as well before we can proceed with execution.</p>",
    from: [{ name: "Legal Team", email: "legal@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    date: ts("2025-01-08T08:05:00Z"),
    unread: true,
    folders: ["INBOX"],
  },

  // Thread 4 — Producer Agreement
  {
    id: "demo-msg-4-1",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-4",
    subject: "Producer Agreement - Analysis Complete",
    snippet: "Your contract analysis is complete. We've identified 3 key terms, 2 potential concerns...",
    body: "<p>Your contract analysis is complete. We've identified 3 key terms, 2 potential concerns, and 5 action items. Click to view the full analysis report.</p>",
    from: [{ name: "EqualIQ System", email: "system@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    date: ts("2025-01-07T16:30:00Z"),
    unread: false,
    folders: ["INBOX"],
  },
  {
    id: "demo-msg-4-2",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-4",
    subject: "Re: Producer Agreement - Analysis Complete",
    snippet: "I took a quick look at the analysis. The payment terms look favorable...",
    body: "<p>I took a quick look at the analysis. The payment terms look favorable. Let's discuss the IP ownership clause in our next meeting.</p>",
    from: [{ name: "Roger Goodell", email: "roger.goodell@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    date: ts("2025-01-07T17:00:00Z"),
    unread: false,
    folders: ["INBOX"],
  },

  // Thread 5 — Netflix Sync License
  {
    id: "demo-msg-5-1",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-5",
    subject: "Netflix Sync License - Exclusivity Negotiation",
    snippet: "Netflix has come back with their proposed sync license terms...",
    body: "<p>Netflix has come back with their proposed sync license terms. The fee structure is better than expected, but the exclusivity period is longer than we discussed.</p>",
    from: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    to: [{ name: "Roger Goodell", email: "roger.goodell@equaliq.demo" }, { name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    date: ts("2025-01-07T10:00:00Z"),
    unread: false,
    folders: ["INBOX", "SENT"],
  },
  {
    id: "demo-msg-5-2",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-5",
    subject: "Re: Netflix Sync License - Exclusivity Negotiation",
    snippet: "I've reviewed the latest version and have some thoughts on the exclusivity clause...",
    body: "<p>I've reviewed the latest version and have some thoughts on the exclusivity clause. Can we negotiate down to 18 months instead of 24?</p>",
    from: [{ name: "Roger Goodell", email: "roger.goodell@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }, { name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    date: ts("2025-01-07T14:00:00Z"),
    unread: false,
    folders: ["INBOX"],
  },
  {
    id: "demo-msg-5-3",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-5",
    subject: "Re: Netflix Sync License - Exclusivity Negotiation",
    snippet: "Agreed with Roger. The fee is good but 24 months is too restrictive...",
    body: "<p>Agreed with Roger. The fee is good but 24 months is too restrictive. Let's counter with 18 months and see how they respond.</p>",
    from: [{ name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }, { name: "Roger Goodell", email: "roger.goodell@equaliq.demo" }],
    date: ts("2025-01-07T14:30:00Z"),
    unread: false,
    folders: ["INBOX"],
  },
  {
    id: "demo-msg-5-4",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-5",
    subject: "Re: Netflix Sync License - Exclusivity Negotiation",
    snippet: "Sounds good. I'll reach out to their team today and propose the 18-month timeline...",
    body: "<p>Sounds good. I'll reach out to their team today and propose the 18-month timeline. Will keep you both updated.</p>",
    from: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    to: [{ name: "Roger Goodell", email: "roger.goodell@equaliq.demo" }, { name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    date: ts("2025-01-07T15:00:00Z"),
    unread: false,
    folders: ["INBOX", "SENT"],
  },

  // Thread 6 — Brand Partnership / NIL Deal
  {
    id: "demo-msg-6-1",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-6",
    subject: "Brand Partnership / NIL Deal - Expiring Soon",
    snippet: "Your contract expires in 30 days. Please review and decide if you'd like to renew...",
    body: "<p>Your contract expires in 30 days. Please review and decide if you'd like to renew or renegotiate terms.</p>",
    from: [{ name: "EqualIQ System", email: "system@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    date: ts("2025-01-05T09:00:00Z"),
    unread: false,
    folders: ["INBOX", "IMPORTANT"],
  },
  {
    id: "demo-msg-6-2",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-6",
    subject: "Re: Brand Partnership / NIL Deal - Expiring Soon",
    snippet: "We should definitely look at renewing this one. The brand partnership has been performing well...",
    body: "<p>We should definitely look at renewing this one. The brand partnership has been performing well. Want to set up a call to discuss renewal terms?</p>",
    from: [{ name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    to: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    date: ts("2025-01-05T11:00:00Z"),
    unread: false,
    folders: ["INBOX"],
  },
  {
    id: "demo-msg-6-3",
    grantId: DEMO_GRANT_ID,
    threadId: "ext-thread-6",
    subject: "Re: Brand Partnership / NIL Deal - Expiring Soon",
    snippet: "Agreed! Let's schedule for next week. I'll prepare some updated metrics...",
    body: "<p>Agreed! Let's schedule for next week. I'll prepare some updated metrics to help with the negotiation.</p>",
    from: [{ name: "Demo User", email: DEMO_CONNECTION_EMAIL }],
    to: [{ name: "Adam Silver", email: "adam.silver@equaliq.demo" }],
    date: ts("2025-01-05T14:00:00Z"),
    unread: false,
    folders: ["INBOX", "SENT"],
  },
];
